import { z } from "zod";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/organisations/{organisationId}/payment-informations").PATCH();

// The handler accepts these fields as omitted, but the generated schema marks them as required.
const updateCompanyPaymentInfoReqSchema = endpoint.req.extend({
    paymentMethodId: z.string().optional(),
    sourceId: z.string().optional(),
    paymentMethodType: z.string().optional(),
});

type UpdateCompanyPaymentInfoReq = z.infer<typeof updateCompanyPaymentInfoReqSchema>;

const call = createCall({ ...endpoint, req: updateCompanyPaymentInfoReqSchema }, (request) =>
    fetch(withAccountAuthHeaders(request)),
);

type UpdateCompanyPaymentInfoParams = {
    organisationId: typeof endpoint.types.P.organisationId;
    data: UpdateCompanyPaymentInfoReq;
};

export async function updateCompanyPaymentInfo({
    organisationId,
    data,
}: UpdateCompanyPaymentInfoParams) {
    return await call({ params: { organisationId }, req: data });
}
